import { useSelector, useDispatch } from "react-redux";
import { loadStudentsActions } from "../store/leaderboard";
export default function Pagination({totalPages}){
    const dispatch = useDispatch();
    const {currentPage} = useSelector(state => state.myLeaderboard);
    function handlePageClick(page){
        dispatch(loadStudentsActions(page))
    }
    return (
        <div>
        <div>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
                key={page}
                onClick={() => handlePageClick(page)}
                style={{
                margin: "5px",
                padding: "10px",
                backgroundColor: (currentPage ?? 1)  === page ? "#007bff" : "white",
                color: (currentPage ?? 1) === page ? "white" : "black",
                border: "1px solid black",
                cursor: "pointer",
                }}
            >
                {page}
            </button>
            ))}
        </div>
        </div>
    );
      
}